import * as React from 'react'

import { cn } from '@/lib/utils'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const OptionsToolbar: React.FC<IProps> = ({ className, children, ...rest }) => {
  return (
    <div
      data-slot="options-toolbar"
      className={cn('tw:flex tw:items-center tw:gap-2 tw:shrink-0', className)}
      {...rest}
    >
      {children}
    </div>
  )
}

export default OptionsToolbar
